import React, { useState } from 'react'
import Divider from '@/components/Divider'
import Image from 'next/image'
import { copyToClipboard } from '@/utils/extras'
import { shortestAddress } from '@/utils/shortenAddress'
import NavigationConnection from '@/components/navigation/NavigationConnection'

const donationAddress = '0xa6679471Cf7021828Ac9C92A49CdC691fB7f4560'

const buttonStyles = {
    position: 'relative',
    zIndex: 10,
    width: '75px',
    height: '20px',
    marginLeft: '5px',
    backgroundColor: 'var(--clr-pink)',
    color: 'var(--clr-white)',
    border: 'none',
    borderRadius: '4px',
    fontFamily: "'Play', sans-serif",
    fontSize: '0.8em',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 250ms ease',
}

const HeaderCopyright = () => {
    const [showTooltip, setShowTooltip] = useState(false)

    return (
        <div className={'center white relative-position z-index-thousand'}>
            <header>
                <Divider />
                <p className={'center white'}>
                    ©&nbsp;Illustre,&nbsp;2025&nbsp;&#11042;&nbsp;
                    <span className={'gradient-text'}>Donate&nbsp;at&nbsp;</span>
                    <Image
                        src="/hexagon-copy.svg"
                        alt="arrow"
                        width={15}
                        height={15}
                        style={{
                            marginLeft: '1px',
                            cursor: 'pointer',
                        }}
                        onClick={() => copyToClipboard(donationAddress, setShowTooltip)}
                    />
                    {!showTooltip && <span className={'gray'}>&nbsp;{shortestAddress(donationAddress)}</span>}
                    {showTooltip && (
                        <span
                            className={'gray'}
                            style={{
                                visibility: showTooltip ? 'visible' : 'hidden',
                                opacity: showTooltip ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                            }}
                        >
                            &nbsp;Copied!
                        </span>
                    )}
                    <NavigationConnection />
                </p>
            </header>
        </div>
    )
}
export default HeaderCopyright
